import type { WorkflowStatusCountResponse } from '../types'
import type {
  WorkflowFilterStatus,
  WorkflowFilterStatusWithoutShowAll,
} from '@app/shared/types/sf-data'

import { decamelize } from 'humps'

import SFetch from '@app/utils/sfetch'

export function getWorkflowFiltersCount({
  defaultStatus,
  ledgerId,
  workflowId,
  requestFilters = [],
}: {
  defaultStatus: WorkflowFilterStatus
  ledgerId: number
  workflowId: number
  requestFilters?: WorkflowFilterStatusWithoutShowAll[]
}): Promise<WorkflowStatusCountResponse | null> {
  const url =
    window.Silverfin.Routes.filters_count_ledger_company_workflow_path(
      window.Silverfin.currentFirmId,
      window.Silverfin.currentCompanyId,
      ledgerId,
      workflowId,
      {
        default_status: defaultStatus,
        request_filters: requestFilters.map(decamelize).join(','),
      }
    )

  return SFetch.json<WorkflowStatusCountResponse>(url)
}
